<template>

    <div class="classPageDiv">
  
      <div class=" mt-20 rounded overflow-x-scroll">
  
          <div v-if="pitchImages.length > 0" class="">
  
              <card-images-component :images="pitchImages" :isTransparent="false"/>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.className')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myPitch.name}}</label>
          </div>
  
  
          <div v-if="myPitch.pay_cash" class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('pitch.cash')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myPitch.cash_hour_price}}</label>
          </div>
  
          <div v-if="myPitch.pay_points" class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('pitch.points')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myPitch.hour_price}}</label>
          </div>
  
  
          <div class="classPageRow">
              
              <label class="mr-5"><strong>{{$t('pitch.minNumber')}}</strong></label>
  
              <label class="classPageDetailsLabel">{{myPitch.min_number}}x{{myPitch.min_number}}</label>
          </div>
  
          <div class="classPageRow">
              
              <label class="mr-5"><strong>{{$t('pitch.maxNumber')}}</strong></label>
  
              <label class="classPageDetailsLabel">{{myPitch.max_number}}x{{myPitch.max_number}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.type')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{type}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.description')}} </strong></label>
  
              <p
              class="classPageDetailsLabel">
              {{myPitch.description}}</p>
          </div>
  
          <div class="mb-40" v-if="stopLoader && (myPitchInfo != null ||  typeof stopLoader == 'undefined')">
  
              <div :key="lastSelectedIndex">
                                
                  <!-- <my-date-bar :myDates="myDates"/> -->
                  <my-date-bar :myDates="myDates" :setDate="setDateFromBar"  :fromPage="true"
                   :useWithPanel="true" :lastSelectedIndex="lastSelectedIndex"/>
              </div>

  
              <div class="mt-4 mySessionsDivider" :key="panelObject.dayDate">
  
  
                  <div class="myPitchCardDiv" ref="slotRef" v-for="(oneSlot, index) in panelObject.categorizedSlots" :key="index">
                      
  
                      <div v-if="clickedSlotId == oneSlot.id" :key="clickedTimes.length" class="mt-8 mb-4">
  
                          <label class="bookingHoursfirstText" v-if="clickedTimes.length == 1" >{{$t('player.youAreBooking')}}
                               <strong class="bookingHoursSecondext">{{$t('player.oneHour')}}</strong></label>
  
                          <label class="bookingHoursfirstText" v-if="clickedTimes.length == 2" >{{$t('player.youAreBooking')}}
                              <strong class="bookingHoursSecondext"> {{$t('player.twoHours')}}</strong></label>
                      </div>
  
                      <pitch-page-card :key="panelObject.dayDate" :disablePage="disablePage"
                              :email="email" :myReload="myReload" :isCard="true" :myPitch="myPitchInfo"
                              :mySlot="oneSlot" :index="index" :dayDate="panelObject.dayDate" 
                              :searchStartTime="searchStartTime" :searchEndTime="searchEndTime" :disableButton="disableButton"
                              :addBookingTime="addBookingTime" :removeBookingTime="removeBookingTime" />
                  </div>
                  
              </div>

          </div>
  
          <div v-else class="myCenter">
  
              <ring-loader v-if="!stopLoader"></ring-loader>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import PitchPageCard from './PitchPageCard'
    
  import componentsHelpers from '../../classes/componentHelpers';
  
  import cardImagesComponent from '../../components-v2/cards-components/CardImages';
  
  import myQueries from '../../hasura/myQueries';
  
  import myTwoQueries from '../../hasura/myTwoQueries';
  
  import myInserts from '../../hasura/myInserts';
  
  import moment from 'moment'
  
  
  import componentsMethods from '../../classes/componentsMethods';
  
  import myDateBar from '../../components-v2/Bars/MyDatesBar'
  import componentHelpers from '../../classes/componentHelpers';
  import myMethods from '../../classes/componentsMethods';
  
  // import MyTabs from '../components-v2/controls/MyTabs';
  // import axios from '@/classes/myAxios'
  import axios from '@/classes/myAxios'
  
  export default {
  
      created()
      {
  
          // console.log(`myClass: ${JSON.stringify(this.myClass)}`);
      },
  
      async mounted(){
        
        this.loadPitchData();

        this.setPitch();
  
          // console.log(`lastDayDate: ${this.lastDayDate}`);
  
          // console.log(`myGroupId: ${this.groupId}`);
      },
  
      props: {
  
          lastDayDate: '',
          
          showPanel: false,
  
          closePitchPage: {
  
              type: Function 
          },
  
          myPitch:{
          
              type: Object,
              default: () => ({})
          },
    
          // myReload: {
  
          //     type: Function
          // }
  
          // classId: 0
      },
  
      components: {
  
          cardImagesComponent,
          myDateBar,
          PitchPageCard,
      },
  
      methods: {

        async loadPitchData(){

             try{  

                // console.log(`in loadpitchdata: ${this.myPitch.id}`);

                    this.loading = true;

                    let result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getPitchWithId',
                        data: {
                            
                            pitchId: this.myPitch.id
                        }
                    });

                    // console.log(`after loading`);

                    this.myPitchInfo = result.data.two_pitch[0];

                    this.pitchSlots = this.myPitchInfo.two_pitch_slots;

                    this.panelObject.categorizedSlots = this.pitchSlots.filter(item=> item);

                    // console.log(`this.panelObject.categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`);

                    this.loading = false;

                }catch(error){

                    console.log(`error: ${error.toString()}`);
                    console.log(error);

                    this.loading = false;
                }
            },
  
          checkLastSelectedDayDate(){
  
              // console.log(`in class page, ${this.lastDayDate}`);
  
              if(this.lastDayDate != ''){
  
                  const tempDate = this.lastDayDate;
  
                  this.lastSelectedIndex =  this.myDates.findIndex(item=> item.date == tempDate);
  
              }
          },
  
           myReload(){
  
              location.reload();
          },
  
          groupIsSelected(group){
  
              // componentsHelpers.printJson('groupIsSelected', group);
  
              this.groupId = group.id;
          },
  
          clearGroup(){
  
              // console.log(`clearGroup`);
              this.groupId = 0;
          },
  
          setPitch(){
  
          //   console.log(`myPitch: ${JSON.stringify(this.myPitch)}`)
  
            try{
  
              this.setType();
  
              if(this.myPitch.image_1 != null && this.myPitch.image_1 != ''){
  
                  this.pitchImages.push(this.myPitch.image_1);
  
                  if(this.myPitch.image_2 != null && this.myPitch.image_2 != ''){
  
                      this.pitchImages.push(this.myPitch.image_2);
                      
                      if(this.myPitch.image_3 != null && this.myPitch.image_3 != ''){
  
                          this.pitchImages.push(this.c.image_3);
  
                          if(this.myPitch.image_4 != null && this.myPitch.image_4 != ''){
  
                              this.pitchImages.push(this.myPitch.image_4);
  
                              if(this.myPitch.image_5 != null && this.myPitch.image_5 != ''){
  
                                  this.pitchImages.push(this.myPitch.image_5);
  
                                  if(this.myPitch.image_6 != null && this.myPitch.image_6 != ''){
  
                                      this.pitchImages.push(this.myPitch.image_6);
  
                                      if(this.myPitch.image_7 != null && this.myPitch.image_7 != ''){
  
                                          this.pitchImages.push(this.myPitch.image_7);
  
                                          if(this.myPitch.image_8 != null && this.myPitch.image_8 != ''){
  
                                              this.pitchImages.push(this.myPitch.image_8);
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  } 
              }
  
  
          }catch(error){
  
              componentsHelpers.sendError(this.$apollo, this.userId,'v2-pitchPage', 'pitchPage', 'mounted - catch', error);
  
              componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
          }
        },
  
        setType(){
            
          //   console.log(`myPitch: ${JSON.stringify(this.myPitch)}`)
              
            this.type = this.myPitch.type.name;
          },
  
          setDateFromBar(date){
  
              this.clickedTimes = new Array();
  
              // this.panelObject.dayDate = date;
  
              const tempDate = moment(date).format(moment.HTML5_FMT.DATE);
  
              // console.log(`tempDate: ${tempDate}`);
              this.panelObject.dayDate = tempDate;
              // console.log(`date: ${this.panelObject.dayDate}`);
  
              // this.$refs.sessionsPanel.setNewDate(tempDate)
              this.setSlots();
          },
  
           setSlots(){
              
              // console.log(`allSlots: ${JSON.stringify(this.allSlots)}`)
              const selectionDay = this.dayOfWeekAsString(new Date(this.panelObject.dayDate).getDay());
              // console.log(`selectionDay: ${selectionDay}`)
  
              const equalMethod = componentsMethods.isEqualToWeeKDayForPitch;
              
              const weekDayFilter = item => equalMethod(item, selectionDay, this.panelObject.dayDate);
  
              if(this.onlyOnline){
  
                  const justOnlineSlots = this.pitchSlots.filter(item => item.class.is_online == true);
                  
                  this.weekDayCategorizedSlots = justOnlineSlots.filter(weekDayFilter);
              }
              else{
  
                  this.weekDayCategorizedSlots = this.pitchSlots.filter(weekDayFilter);
              }
  
              // console.log(`weekDayCategorizedSlots: ${JSON.stringify(this.weekDayCategorizedSlots)}`)
              // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`)
  
              this.timedCategorizedSlots = this.weekDayCategorizedSlots.filter(item => item);
              componentsMethods.sortTimes(this.timedCategorizedSlots);
  
              this.panelObject.categorizedSlots = this.timedCategorizedSlots;
  
              // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`);
  
              // console.log(`date: ${this.panelObject.dayDate}`)
  
              // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`)
          },
  
          dayOfWeekAsString(dayIndex) {
          
              return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
          },
  
          getDuration(){
  
              const hour = ((this.bookingEndTime - this.bookingStartTime)/ (1000*3600));
  
              // const duration = moment.duration({"minutes": minutes}).humanize();
              return hour;
          },
  
          calculatePoints(hourPrice){
  
              return this.getDuration() * hourPrice;
          },
  
  
          addBookingTime(time, slotId, clearClicked){
  
              //   alert(`time: ${time}`)
              
              if(this.clickedSlotId == 0){
  
                  this.clickedTimes.push(time);
  
                  this.clickedSlotId = slotId;
              }else{
  
                  if(this.clickedSlotId == slotId ){
  
                      if(this.clickedTimes.length == 1){
                                      
                          const nextTime = componentsMethods.getDateOfNextTime(this.clickedTimes[0]);
                          const prevTime = componentsMethods.getDateOfPrevTime(this.clickedTimes[0]);
  
                          const newTime = componentsMethods.getDateOfTime(time);
  
                          if(moment(nextTime).hour() == moment(newTime).hour()){
  
                              this.clickedTimes.push(time);
  
                          }else if(moment(prevTime).hour() == moment(newTime).hour()){
                              // console.log(`equal true;`)
  
                              const tempTime = this.clickedTimes[0];
  
                              this.clickedTimes.pop();
                              
                              this.clickedTimes.push(time);
  
                              this.clickedTimes.push(tempTime);   
                          }
                          else{
  
                              // console.log(`equal false;`)
  
                              clearClicked();
                          }
  
                          // console.log(`clickedTimes: ${JSON.stringify(this.clickedTimes)}`);
  
                      }else if(this.clickedTimes.length > 1){
  
                              // console.log(`length > 1;`)
  
                              clearClicked();
  
                      }else if(this.clickedTimes.length == 0){
                          
                          this.clickedTimes.push(time);
  
                          this.clickedSlotId = slotId;
                      } 
                  }else{
  
                  if(this.clickedTimes.length == 1){
  
                      this.clearFirstClicked();
                  }
                  else if(this.clickedTimes.length == 2){
  
                      this.clearFirstClicked();
  
                      this.clearSecondClicked();
                  }
  
                  this.clickedSlotId = slotId;
  
                  this.clickedTimes = [];
  
                  this.clickedTimes.push(time);
                  }
              }
  
              // console.log(`clickedTimes: ${JSON.stringify(this.clickedTimes)}`);
          },
  
          removeBookingTime(time, slotId, clearClicked){
  
              if(this.clickedSlotId == slotId){
  
                  if(this.clickedTimes.length > 1){
  
                  if(this.clickedTimes[1] == time){
  
                      this.clickedTimes.pop();
  
                      clearClicked();
                      // this.clearSecondClicked = null;
  
                  }else if(this.clickedTimes[0] == time){
                      
                      const tempTime = this.clickedTimes[1];
                      
                      this.clickedTimes = [];
  
                      this.clickedTimes.push(tempTime);
  
                      clearClicked();
  
                  }
                  }else if(this.clickedTimes.length == 1){
                  
                  if(this.clickedTimes[0] == time){
  
                      this.clickedTimes = [];
  
                      clearClicked();
                  }   
              }
  
              // console.log(`clickedTimes: ${JSON.stringify(this.clickedTimes)}`);  
  
          }
  
          if(this.clickedTimes.length == 0){
  
              this.clickedSlotId == 0;
          }
          },
  
          clearClicks(){
  
              this.clearFirstClicked();
  
              this.clearSecondClicked();
  
              this.clickedSlotId == 0;
  
              this.clickedTimes = [];
          },
      },
  
      apollo:{

  
          pitch: {
  
              query: myTwoQueries.pitch_with_id_query,
  
              variables: function(){
  
                  return{
  
                      pitchId: this.myPitch.id
                  }
              },
  
              update(data){
  
                  this.stopLoader = true;
                  // console.log(`apollo two_pitch: ${JSON.stringify(data.two_pitch[0])}`)
  
                  this.myPitchInfo = data.two_pitch[0];
  
                  this.listOfWeekDays =  componentsMethods.findWeekDays(this.myPitchInfo.two_pitch_slots);
  
                  this.myDates = componentsMethods.getDates(this.listOfWeekDays);
  
                  this.checkLastSelectedDayDate();
  
                  this.pitchSlots = this.myPitchInfo.two_pitch_slots;
                  
                  this.panelObject.categorizedSlots = this.pitchSlots.filter(item=> item);
  
                  // console.log(`categorizedSlots.length: ${this.panelObject.categorizedSlots.length}`);
  
                  // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`);
                  return data.two_pitch;
              },
  
  
              error(error){
                  
                  if(this.slotQueryError == ''){
                  // console.log(`in query`);
                      this.slotQueryError = error;
  
                      componentsHelpers.sendError(this.$apollo, 0,'v2-ClassPage', 'apollo', 'class query', error);
  
                      componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
  
                      this.slotError = JSON.stringify(error);
                  }
              },
              skip(){
  
                  // console.log(`this.$userId: ${this.$userId}`)
                  return JSON.stringify(this.$userId) == '{}';
                }
          },
      },
  
      data: function() {
  
          return {
              
              panelObject:{
  
                  minimizeAll: false,
                  onlyOnline: false,
                  categorizedSlots: new Array(),
                  dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
              },
              
              myPitchInfo: null,
              pitchSlots: null,

              disablePage: false,
              email:'',
              user:[],
              player:[],
              stopLoader: false,
              listOfWeekDays: [false, false, false, false, false, false, false],
              classInfo: null,
              user:[],
              pitchImages: [],
              fixedDayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
              type: '',
              showBusiness: false,
              showInstructor: false,
              userQueryError: '',            
              slotQueryError: '',
              tokenId: '',
              email: '',
              userId: 0,
              myDates: [],
              disableButton: false,
              searchStartTime: '08:00',
              searchEndTime: '23:00',
              clearFirstClicked: null,
              clearSecondClicked: null,
              clickedSlotId: 0,
              clickedTimes: [],
  
              playersGroupsOptions: [],
  
              storedKey: localStorage.getItem('for_pnadi'),
  
              lastSelectedIndex: 0,
  
          }
      },  
  }
  </script>
  
  <style lang="scss">
  
  label{
    width: 150px;
  }
  
  
  </style>